/*
 * Shared add-to-cart for PDP upsell rows (Same Collection / Complete the Look).
 * Button labels come from data-* attributes so copy stays localized in Liquid.
 */
(function () {
  function bindButton(btn) {
    if (!btn || btn.dataset.bound || btn.disabled) return;
    btn.dataset.bound = 'true';

    btn.addEventListener('click', function () {
      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      var labelAdd = btn.dataset.labelAdd || btn.textContent;
      var labelAdding = btn.dataset.labelAdding || labelAdd;
      var labelAdded = btn.dataset.labelAdded || labelAdd;

      btn.disabled = true;
      btn.textContent = labelAdding;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(function () {
          btn.textContent = labelAdded;
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          setTimeout(function () {
            btn.textContent = labelAdd;
            btn.disabled = false;
          }, 1500);
        })
        .catch(function (err) {
          console.error('Add to cart failed:', err);
          btn.textContent = labelAdd;
          btn.disabled = false;
        });
    });
  }

  function init() {
    document.querySelectorAll('.pdp-upsell-row__button').forEach(bindButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
